import { FC } from 'react';
import styles from './Tabs.styles.module.css';

export enum TabsVariant {
  SPACED = 'SPACED',
  COMPACT = 'COMPACT',
}
interface TabsProps {
  children: React.ReactNode;
  variant?: TabsVariant;
  customStyle?: string;
}

const variantClassesMap = {
  [TabsVariant.SPACED]: styles.tabs,
  [TabsVariant.COMPACT]: `${styles.tabs} ${styles['tabs--compact']}`,
};

const Tabs: FC<TabsProps> = ({
  children,
  variant = TabsVariant.SPACED,
  customStyle = '',
}) => {
  const variantClass = variantClassesMap[variant];

  return (
    <div role='tablist' className={`${variantClass} ${customStyle}`}>
      {children}
    </div>
  );
};

Tabs.displayName = 'Tabs';
export default Tabs;
